import ScheduleDeliveryTabs from "./ScheduleDeliveryTabs";

export default ScheduleDeliveryTabs;
